/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DeploymentInputs */

const en_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deployment`)
};

const ar_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشر`)
};

const bn_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডিপ্লয়মেন্ট`)
};

const de_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitstellung`)
};

const es_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implementación`)
};

const fr_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déploiement`)
};

const pt_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Implantação`)
};

const zh_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部署`)
};

const tr_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dağıtım`)
};

const ru_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развертывание`)
};

const pl_svchip_deployment = /** @type {(inputs: Svchip_DeploymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie`)
};

/**
* | output |
* | --- |
* | "Deployment" |
*
* @param {Svchip_DeploymentInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_deployment = /** @type {((inputs?: Svchip_DeploymentInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DeploymentInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_deployment(inputs)
	if (locale === "bn") return bn_svchip_deployment(inputs)
	if (locale === "de") return de_svchip_deployment(inputs)
	if (locale === "es") return es_svchip_deployment(inputs)
	if (locale === "fr") return fr_svchip_deployment(inputs)
	if (locale === "pt") return pt_svchip_deployment(inputs)
	if (locale === "zh") return zh_svchip_deployment(inputs)
	if (locale === "tr") return tr_svchip_deployment(inputs)
	if (locale === "ru") return ru_svchip_deployment(inputs)
	if (locale === "pl") return pl_svchip_deployment(inputs)
	return en_svchip_deployment(inputs)
});